// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-input[data-v-039721b1]{margin:0 15px 15px 15px}[data-v-039721b1] .emoji-picker{left:unset!important;top:unset!important}", ""]);
// Exports
module.exports = exports;
